import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Modal } from '@offerzen/pinata-shame'

import { registerModal, hideModal as hideModalAction, destroyModal } from './reducers'
import { modalVisible } from './selectors'

/**
 * ModalRedux component
 *
 * @param {Object} props
 * @param {(''|'default'|'small'|'medium'|'large')} [props.size]
 * @param {Function} [props.onModalClose]
 * @param {boolean} [props.preventClose]
 * @param {Function} props.children
 * @param {string} [props.className]
 * @param {boolean} props.visible
 * @param {Function} props.hideModal
 * @param {Function} props.dispatchRegisterModal
 * @param {Function} props.dispatchDestroyModal
 *
 * @returns {JSX.Element}
 */
const ModalRedux = ({ dispatchRegisterModal, dispatchDestroyModal, hideModal, visible, ...props }) => {
  useEffect(() => {
    dispatchRegisterModal()

    return () => {
      dispatchDestroyModal()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      hideModal={hideModal}
      visible={visible}
    />
  )
}

const makeMapStateToProps = () => {
  const visible = modalVisible()

  const mapStateToProps = (state, ownProps) => ({
    visible: visible(state, ownProps.name),
  })

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchRegisterModal: () => dispatch(registerModal(ownProps.name)),
  dispatchDestroyModal: () => dispatch(destroyModal(ownProps.name)),
  hideModal: () => dispatch(hideModalAction(ownProps.name)),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(ModalRedux)
